export default __webpack_public_path__ + "static/media/hp-prev-program-02-desktop.838e1487.jpg";